module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-tisch-nicolas.72f3711c.jpg";